import ApolloClient from 'apollo-client';
import {setContext} from "apollo-link-context";
import {createHttpLink} from "apollo-link-http";
import {InMemoryCache} from "apollo-cache-inmemory";
import {serverConfig} from "./config";
import {getJWTToken} from "../utils/getJWTToken";
import fetch from 'node-fetch';

const httpLink = createHttpLink({
    fetch: fetch as any,
    uri: serverConfig.url,
});

const authLink = setContext((_, { headers }) => {
    // get the authentication token from wherever you store it
    const token = getJWTToken();
    // return the headers to the context so httpLink can read them
    return token ? {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        },
    } : {};
});

export const client = new ApolloClient({
    link: authLink.concat(httpLink),
    // cache: new InMemoryCache()
    cache: new InMemoryCache({
        // freezeResults: true,
        // resultCaching: false
    }),
    defaultOptions: {
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        },
    }
    // assumeImmutableResults: true,
});
